import * as chrono from "chrono-node";
import * as moment from "moment";
/*
 * Please see the following:
 * - http://momentjs.com/guides/#/warnings/js-date/
 * - https://github.com/moment/moment/issues/1407
 */
var convertToISOString = function (dateString) {
    return moment(new Date(dateString))
        .utc(dateString)
        .toISOString();
};
export var schemaDate = function (date) {
    if (!chrono.parse(date).length) {
        return {
            endDate: "",
            startDate: "",
        };
    }
    var parsedStartDate = chrono.parse(date)[0].start;
    var parsedEndDate = chrono.parse(date)[0].end;
    var startDate = typeof parsedStartDate !== "undefined" ?
        convertToISOString(parsedStartDate.date().toString()) : "";
    var endDate = typeof parsedEndDate !== "undefined" ?
        convertToISOString(parsedEndDate.date().toString()) : "";
    return {
        endDate: endDate || startDate,
        startDate: startDate,
    };
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/schema/schemaDate.ts
// module id = aadl
// module chunks = 2